import { render } from "./iptv-channel-stat.vue?vue&type=template&id=39f5969c"
import script from "./iptv-channel-stat.vue?vue&type=script&lang=js"
export * from "./iptv-channel-stat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__